import React, { useEffect, useRef } from "react";
import { Route, Routes, useLocation } from "react-router";
import { authRoutes, publicRoutes } from "./router.link";
import { all_routes } from "./all_routes";
import Feature from "../feature";
import AuthFeature from "../authFeature";
import Login from "../auth/login";
import { Helmet, HelmetProvider } from "react-helmet-async";

const ALLRoutes: React.FC = () => {
  const location = useLocation();

  // Find the current route in either public or auth routes
  const currentRoute = publicRoutes.find(route => route.path === location.pathname) ||
                       authRoutes.find(route => route.path === location.pathname);

  // Construct the full title
  const fullTitle = currentRoute?.title
    ? `${currentRoute.title} | A2R`
    : "A2R";

  useEffect(() => {
    document.title = fullTitle;
  }, [fullTitle]);

  // Workaround: a aba "Status" do Dashboard Analytics some do DOM quando se
  // navega até ela via SPA vindo do Kanban de Oportunidades (causa raiz não
  // encontrada - ver diagnóstico em mainMenu/dashboardAnalytics/index.tsx).
  // Um F5 sempre resolve, então força um reload completo nesse trajeto
  // específico pra reproduzir o mesmo efeito. Só reloada uma vez: depois do
  // reload a página carrega do zero, sem "rota anterior" em memória, então a
  // condição abaixo não bate de novo.
  const previousPathnameRef = useRef<string | null>(null);
  useEffect(() => {
    const previousPathname = previousPathnameRef.current;
    previousPathnameRef.current = location.pathname;

    if (
      previousPathname?.startsWith(all_routes.dealsKanban) &&
      location.pathname === all_routes.dashboardAnalytics
    ) {
      window.location.reload();
    }
  }, [location.pathname]);

  return (
    <>
      <Helmet>
        <title>{fullTitle}</title>
      </Helmet>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route element={<Feature />}>
          {publicRoutes.map((route, idx) => (
            <Route path={route.path} element={route.element} key={idx} />
          ))}
        </Route>
        <Route element={<AuthFeature />}>
          {authRoutes.map((route, idx) => (
            <Route path={route.path} element={route.element} key={idx} />
          ))}
        </Route>
      </Routes>
    </>
  );
};

export default ALLRoutes;
